import Component from "../../lib/component";
import iconCross from "./assets/icon__cross.svg";

export const PaneSlideFlipConfig = {
    componentTypeKey: 'PaneSlideFlip',
    baseHtmlClass: 'pane_slides__flip',
    selector: '.pane_slides__flip',

    exitButtonBaseHtmlClass: 'pane_slides__flip__x',
};

export class PaneSlideFlip extends Component {

    static get config() {
        return PaneSlideFlipConfig;
    }

    constructor(id_or_element, paneSlide) {
        super({
            element: id_or_element,
            config: PaneSlideFlip.config
        });

        this.paneSlide = paneSlide;

        this.isFlipped = false; // Is it flipped?
        this.isUnflipped = true; // Is it unflipped?
        this.isFlipping = false; // In the process of flipping from unflipped to flipped
        this.isUnflipping = false; // In the process of unflipping from flipped to unflipped

        this.exitButton = createExitButton(this);

        // The flip settles a full second later, so a carousel torn down mid-flip would otherwise
        // leave a timer running against a detached element. One id serves both directions — the
        // guards in doFlip/undoFlip mean only one can ever be in flight.
        this.flipTimeoutId = null;
        this.onDestroy(() => window.clearTimeout(this.flipTimeoutId));
    }

    toggleFlip() {
        (!!this.isFlipped) ? this.undoFlip() : this.doFlip();
    }

    doFlip() {
        if (this.isFlipping || this.isUnflipping) return; // Don't flip if already flipping or unflipping
        this.isFlipped = false // No longer flipped!
        this.isUnflipped = false; // No longer unflipped!
        this.isFlipping = true; // Now flipping!
        this.isUnflipping = false; // No longer unflipping!
        this.flipTimeoutId = window.setTimeout(() => {
            // After the timeout we have a new state
            this.isFlipped = true;
            this.isUnflipped = false;
            this.isFlipping = false;
            this.isUnflipping = false;
            this.render();
        }, 1000);
        this.render();
    }

    undoFlip() {
        if (this.isFlipping || this.isUnflipping) return; // Don't flip if already flipping or unflipping
        this.isFlipped = false // No longer flipped!
        this.isUnflipped = false; // No longer unflipped!
        this.isFlipping = false; // No longer flipping!
        this.isUnflipping = true; // Now unflipping!
        this.flipTimeoutId = window.setTimeout(() => {
            // After the timeout we have a new state
            this.isFlipped = false;
            this.isUnflipped = true;
            this.isFlipping = false;
            this.isUnflipping = false;
            this.render();
        }, 1000);
        this.render();
    }

    getFlipState() {
        if (this.isFlipped) { return 'flipped' }
        if (this.isFlipping) { return 'flipping' }
        if (this.isUnflipping) { return 'unflipping' }
        if (this.isUnflipped) { return 'unflipped' }
        return 'unflipped'; // Should never get here!
    }

    render() {
        this.selectHtmlClassState(this.getFlipState(), ['unflipped', 'flipping', 'flipped', 'unflipping']);
    }

}

function createExitButton(paneSlideFlip) {
    const element = Component.createElement(PaneSlideFlipConfig.exitButtonBaseHtmlClass, { tagName: 'button' });
    element.setAttribute('title', 'Close');
    const svgElement = new DOMParser().parseFromString(iconCross, "image/svg+xml").documentElement;
    svgElement.style.cssText = "display:block;height:100%;width:100%;";
    element.appendChild(svgElement);
    element.addEventListener('click', paneSlideFlip.toggleFlip.bind(paneSlideFlip));
    const headerElement = paneSlideFlip.element.querySelector('.pane_slides__flip__h');
    headerElement.appendChild(element);
    return element;
}